import React from 'react';
import {useNavigate} from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({activeTab, onTabChange, onLogout}) => {
    const navigate = useNavigate();
    const menuItems = [
        {id: 'overview', label: 'Vue d\'ensemble'},
        {id: 'profile', label: 'Mon Profil'},
        {id: 'quotes', label: 'Mes Devis'},
        {id: 'products', label: 'Produits'},
        {id: 'factures', label: 'Factures'},
        {id: 'reclamations', label: 'Réclamations'},
        {id: 'cart', label: 'Panier'},
    ];

    return (
        <div className="entreprise-sidebar">
            <div className="sidebar-header">
                <img
                    src="/logosastra.png"
                    alt="Sastra Energy"
                    className="sidebar-logo"
                />
                <div className="b2b-badge">B2B SOLUTIONS</div>
            </div>
            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                        onClick={() => onTabChange(item.id)}
                    >
                        <span className="nav-label">{item.label}</span>
                    </button>
                ))}
            </nav>
            <div className="sidebar-footer">
                <button className="home-link-btn" onClick={() => navigate('/home')}>
                    <span className="nav-label"> Retour au site</span>
                </button>
                <div className="footer-divider"></div>
                <button className="logout-btn" onClick={onLogout}>
                    <span className="nav-label">🚪 Déconnexion</span>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
